import { normalizeText as normalize } from '@odd/domain';

export { normalize };

/**
 * Búsqueda por palabras: todas las palabras de la consulta tienen que aparecer (en cualquier orden y en
 * cualquiera de los campos). «dona mercedes acta» encuentra «Acta … · Edificio Doña Mercedes».
 */
export function makeMatcher(query: string) {
  const words = normalize(query).split(' ').filter(Boolean);
  if (!words.length) return () => true;
  return (...fields: (string | null | undefined)[]) => {
    const hay = normalize(fields.filter(Boolean).join(' '));
    return words.every((w) => hay.includes(w));
  };
}
